import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { setMinHeight } from "./utils/_utils";
jQuery(function ($) {
  $(document).on('click', '#customer_login .close', function () {
    jQuery.magnificPopup.close();
  });
  $(document).on('click', '.woocommerce-error .close', function () {
    $(this).closest('.woocommerce-error.message-wrapper').remove();
  });
  $(document).on('click', '.whatsapp-message', function () {
    var wa_url = $(this).data('wa-number');
    if ($(window).width() > 970) {
      wa_url = 'https://web.whatsapp.com/send?phone=' + wa_url.replace('https://wa.me/', '');
    }
    parent.window.open(wa_url, '_blank');
  });
});